import { Portal } from '@chakra-ui/react';
import type { FC } from 'react';

import { CloseButton } from '../CloseButton';
import { DialogOrDrawer } from '../DialogOrDrawer';
import { DefaultContent } from './components/DefaultContent';
import { GraduateModalFooter } from './components/GraduateModalFooter';
import { useGraduateModal } from './useGraduateModal';

export const GraduateModal: FC = () => {
  const isOpen = useGraduateModal((s) => s.isOpen);
  const closeModal = useGraduateModal((s) => s.closeModal);

  return (
    <DialogOrDrawer.Root
      open={isOpen}
      placement={{
        desktopDown: 'bottom',
        desktop: 'top',
      }}
      onOpenChange={(state) => !state.open && closeModal()}
    >
      <DialogOrDrawer.Backdrop />
      <Portal>
        <DialogOrDrawer.Positioner>
          <DialogOrDrawer.DragContent>
            <DialogOrDrawer.Header>Agent Graduated!</DialogOrDrawer.Header>
            <DialogOrDrawer.CloseTrigger asChild>
              <CloseButton />
            </DialogOrDrawer.CloseTrigger>
            <DialogOrDrawer.Body>
              <DefaultContent />
            </DialogOrDrawer.Body>
            <DialogOrDrawer.Footer alignItems="stretch">
              <GraduateModalFooter />
            </DialogOrDrawer.Footer>
          </DialogOrDrawer.DragContent>
        </DialogOrDrawer.Positioner>
      </Portal>
    </DialogOrDrawer.Root>
  );
};
